import {
  RECEIVE_ACCESS_TOKEN,
  RECEIVE_ID_TOKEN,
  RECEIVE_EXPIRES_IN,
  GENERATE_STATE_AND_NONCE
} from "../util/actionTypes";

export const receiveAccessToken = accessToken => ({
  type: RECEIVE_ACCESS_TOKEN,
  payload: { accessToken }
});

export const receiveIdToken = idToken => ({
  type: RECEIVE_ID_TOKEN,
  payload: { idToken }
});

export const receiveExpiresIn = expiresIn => ({
  type: RECEIVE_EXPIRES_IN,
  payload: { expiresIn }
});

export const generateStateAndNonce = () => ({
  type: GENERATE_STATE_AND_NONCE
});
